import React from 'react'
import LogoLight from '../../images/logo_light.svg'
import '../../styles/css/footer.css'

const GetYear = () => (new Date()).getFullYear()

const links = [
  { title: 'About us', target: 'about' },
  { title: 'Film portfolio', target: 'film' },
  { title: 'Photography', target: 'photography' },
  { title: 'Music production', target: 'music' },
  { title: 'Services', target: 'services' },
  { title: 'Contact', target: 'contact' }
]

const Footer = ({ scroll, socials = {} }) => (
  <div className="footer">
    <div className="footer-content">
        <div className="col">
            <img src={LogoLight} alt="New Ground Entertainment" />
            <p>© {GetYear()} All rights reserved.</p>
        </div>
        <div className="col">
            <ul>
              <h1>Site Links</h1>
              {links.map((link,index) => 
              <li key={index}>
                <button onClick={() => scroll(link.target)}>{link.title}</button>
              </li>
              )}
            </ul>
            <ul>
              <h1>Social Media</h1>
              <li><a href={socials.vimeo} target="_blank">Vimeo</a></li>
              <li><a href={socials.instagram} target="_blank">Instagram</a></li>
            </ul>
        </div>
    </div>
  </div>
)

export default Footer


// WEBPACK FOOTER //
// ./src/containers/home/footer.js